import { ActionReducerMapBuilder, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';
import { ICompletedTicket } from '../../../interfaces/ticket/ticket.interface';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}

interface IState {
  status: Status | '';
  data: ICompletedTicket | any;
  error: any;
}

const initialState: IState = {
  status: '',
  data: null,
  error: null,
};

export const checkNewCompletedTickets = createAsyncThunk('vendor-completed-tickets', async () => {
  const vendorId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<ICompletedTicket>(`${VENDOR_MC_URL}/${vendorId}/vendor-completed-tickets`);
  return res.data;
});

const completedTicketSlice = createSlice({
  name: 'completed-tickes',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(checkNewCompletedTickets.pending, (state) => {
      state.status = Status.loading;
    });
    builder.addCase(checkNewCompletedTickets.fulfilled, (state, action) => {
      state.status = Status.done;
      state.data = action.payload;
    });
    builder.addCase(checkNewCompletedTickets.rejected, (state) => {
      state.error = 'Mesajlar Listelenmedi!';
      state.status = Status.fail;
    });
  },
});

export default completedTicketSlice.reducer;
